import { useGetLocationGroupTreeSuspense } from "@/orval/gen"
import { TreePillsInput } from "../tree/tree-pills-input"
import { useTranslation } from "react-i18next"

interface LocationTreeSelectProps {
  value?: string[] | null | undefined
  onChange?: (value: string[]) => void
}

export function LocationTreeSelect({
  value,
  onChange,
  ...props
}: LocationTreeSelectProps) {
  const { data: locationTree } = useGetLocationGroupTreeSuspense()
  const { t } = useTranslation("app_server")
  return (
    <TreePillsInput
      initialCheckedState={value ?? []}
      tree={locationTree.tree}
      label={t("Locations")}
      onCheckedStateChange={onChange}
      {...props}
    />
  )
}
